import { http } from "@/utils/http"; // eslint-disable-line

export default {
  loadSettings () {
    return new Promise((resolve, reject) => {
      http.main.get('/settings').then(async (res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setSTToken (stToken) {
    return new Promise((resolve, reject) => {
      http.main.post('/settings/setSTToken', {token: stToken}).then(async (res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
};
